export const SET_GLOBAL_MESSAGE = 'app/MessageHandler/SET_GLOBAL_MESSAGE';
